import { render, staticRenderFns } from "./VInput.vue?vue&type=template&id=6cf1e58c"
import script from "./VInput.vue?vue&type=script&lang=ts"
export * from "./VInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports